module.exports = __webpack_public_path__ + "img/thin-farm-01.7fe43b97.jpg";